import { ReviewCount, ReviewData } from 'interfaces/reviews-test';

/**
 * Change review count style
 */
export const changeReviewCountStyle = (widgetRef: HTMLElement | null): void => {
  if (widgetRef) {
    const targetElement = widgetRef.querySelector(
      '.jdgm-rev-widg__summary-text'
    );

    if (targetElement && targetElement.textContent) {
      const text = targetElement.textContent;
      const parts = text.split(' ');

      parts[0] = `<span class="font-black text-lg">${parts[0]}</span>`;

      const modifiedText = parts.join(' ');
      targetElement.innerHTML = modifiedText;
    }
  }
};

/**
 * Update review count
 */
export const updateReviewCount = ({
  hasAppliedFakeValues,
  reviewCount,
  widgetRef,
}: {
  hasAppliedFakeValues: boolean;
  reviewCount: ReviewCount;
  widgetRef: HTMLElement | null;
}): void => {
  if (widgetRef && reviewCount) {
    const targetElement = widgetRef.querySelector(
      '.jdgm-rev-widg__summary-text'
    );

    const elementDetails = widgetRef.querySelector('.jdgm-histogram');
    const histogramRows = elementDetails?.querySelectorAll(
      '.jdgm-histogram__row'
    );

    if (
      reviewCount &&
      targetElement &&
      targetElement.textContent &&
      !hasAppliedFakeValues
    ) {
      histogramRows?.forEach((row) => {
        const rating = row.getAttribute('data-rating');
        let count;
        switch (rating) {
          case '5':
            count = reviewCount.fiveStarCount;
            break;
          case '4':
            count = reviewCount.fourStarCount;
            break;
          case '3':
            count = reviewCount.threeStarCount;
            break;
          case '2':
            count = reviewCount.twoStarCount;
            break;
          case '1':
            count = reviewCount.oneStarCount;
            break;
          default:
            return;
        }

        const percentage = Math.round(
          (parseInt(count) / parseInt(reviewCount.reviewsCount)) * 100
        );

        row.setAttribute('data-frequency', count);
        row.setAttribute('data-percentage', percentage.toString());

        const frequencyEle = row.querySelector('.jdgm-histogram__frequency');
        const percentageEle = row.querySelector('.jdgm-histogram__percentage');
        const barContentEle = row.querySelector('.jdgm-histogram__bar-content');

        if (frequencyEle) frequencyEle.textContent = `(${count})`;
        if (percentageEle) percentageEle.textContent = `${percentage}%`;
        if (barContentEle)
          (barContentEle as HTMLElement).style.width = `${percentage}%`;
      });

      const text = targetElement.textContent;
      const parts = text.split(' ');

      parts[0] = reviewCount.ratingCount;
      parts[1] = `(${reviewCount.reviewsCount}`;
      const modifiedText = parts.join(' ');
      targetElement.innerHTML = modifiedText;

      changeReviewCountStyle(widgetRef);

      hasAppliedFakeValues = true;
    }
  }
};

export const addFakeReviews = ({
  reviewData,
  widgetRef,
}: {
  reviewData: ReviewData;
  widgetRef: HTMLElement | null;
}): void => {
  if (!widgetRef || !reviewData) return;

  let reviewsToShow = 2;

  // Create attribute part
  const attributesHTML = reviewData.attributes.reduce((pre, cur) => {
    const pointIdex = cur.value;
    let pointPart = '';
    for (let index = 0; index < 5; index++) {
      if (index < pointIdex) {
        pointPart =
          pointPart +
          '<div class="mr-1 inline-block h-3 w-8 bg-[#339999] margin-left-1"></div>';
      } else {
        pointPart =
          pointPart +
          '<div class="mr-1 inline-block h-3 w-8 bg-[#33999980] margin-left-1"></div>';
      }
    }
    return (
      pre +
      `
          <div class="flex items-center align-middle"><span class="font-bold ">${cur.key} :</span>
            ${pointPart}
          </div>
        `
    );
  }, '');

  // Create reviews part
  let reviewsHtml = generateReviewsHtml(
    reviewData.reviews,
    attributesHTML,
    reviewsToShow
  );

  // Create dummy load more button and attach event
  const loadMoreButton = widgetRef.querySelector('.jdgm-paginate');
  const dummyButton = createDummyLoadMoreButton();
  dummyButton.addEventListener('click', () => {
    setTimeout(() => {
      reviewsToShow = 4;
      reviewsHtml = generateReviewsHtml(
        reviewData.reviews,
        attributesHTML,
        reviewsToShow
      );
      newElement.innerHTML = reviewsHtml;
    }, 2500);
  });

  // Replace the load more button with the dummy button
  if (loadMoreButton && loadMoreButton.parentNode) {
    loadMoreButton.parentNode.replaceChild(dummyButton, loadMoreButton);
  }

  // Clean up existing reviews
  const topEle = widgetRef.querySelectorAll('.jdgm-divider-top');
  topEle.forEach((ele) => {
    ele.remove();
  });
  const hederEle = widgetRef.querySelectorAll('.jdgm-rev__header');
  hederEle.forEach((ele) => {
    ele.remove();
  });
  const contentEle = widgetRef.querySelectorAll('.jdgm-rev__content');
  contentEle.forEach((ele) => {
    ele.remove();
  });
  const titleEle = widgetRef.querySelectorAll('.jdgm-rev__title');
  titleEle.forEach((ele) => {
    ele.remove();
  });
  const reviews = widgetRef.querySelectorAll('.ab-test-reviews');
  reviews.forEach((ele) => {
    ele.remove();
  });
  const newElement = document.createElement('div');
  newElement.className = 'ab-test-reviews';
  newElement.innerHTML = reviewsHtml;
  const textBodyElement = widgetRef.querySelectorAll('.jdgm-rev-widg__reviews');
  textBodyElement.forEach((ele) => {
    ele.appendChild(newElement);
  });
};

/**
 * Disable sortring for reviews
 */
export const disableSort = (widgetRef: HTMLElement | null): void => {
  if (!widgetRef) return;

  const sortPulldownElement = widgetRef.querySelector(
    '.jdgm-rev-widg__sort-wrapper'
  ) as HTMLElement;

  const containerElement = widgetRef.querySelector(
    '.jdgm-histogram'
  ) as HTMLElement;

  if (containerElement && sortPulldownElement) {
    sortPulldownElement.style.display = 'none';
    containerElement.style.pointerEvents = 'none';
    Array.from(containerElement.children).forEach((child) => {
      (child as HTMLElement).style.pointerEvents = 'none';
    });
  }
};

/**
 * Helper function to create dummy load more button
 */
const createDummyLoadMoreButton = (): HTMLDivElement => {
  const dummyButton = document.createElement('div');

  dummyButton.setAttribute('class', 'jdgm-paginate');

  const dummyAnchor = document.createElement('a');

  dummyAnchor.setAttribute(
    'class',
    'jdgm-btn jdgm-btn--solid jdgm-paginate__load-more'
  );

  dummyAnchor.innerText = 'Mehr Laden';

  dummyButton.appendChild(dummyAnchor);

  return dummyButton;
};

/**
 * Helper function to generate reviews html
 */
const generateReviewsHtml = (
  reviews: ReviewData['reviews'],
  attributesHTML: string,
  reviewsToShow: number
): string => {
  return reviews.slice(0, reviewsToShow).reduce((pre, cur) => {
    pre =
      pre +
      `
        <div class="pt-4 margin-top-4 border-t" />
        <div class="jdgm-rev__header ">
          <div class="jdgm-rev__icon ab-reviews-test"> ${cur.name[0]} 
            <div
              class="absolute bottom-0 right-0 flex h-4 w-4 items-center justify-center rounded-full border border-other-white bg-[#333333] text-center text-xxs text-text-dark-bg-contrast-white">
              <span>✓</span>
            </div>
          </div>
          <span class="jdgm-rev__rating" data-score="5" aria-label="5 star review"
            role="img"> <span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span
              class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span
              class="jdgm-star jdgm--on"></span> </span> <span class="jdgm-rev__timestamp"
            data-content="2024-03-28 07:14:42 UTC">28/03/2024</span>
          <div class="jdgm-rev__br"></div> <span class="jdgm-rev__buyer-badge-wrapper"> <span
              class="jdgm-rev__buyer-badge"></span> </span> <span class="jdgm-rev__author-wrapper"> <span
              class="jdgm-rev__author">${cur.name}</span> <span class="jdgm-rev__location"> </span> </span>
        
        <div class="jdgm-rev__body">
          <p>${cur.text}</p>
            ${attributesHTML}
        </div>
      `;
    return pre;
  }, '');
};
